import axios from 'axios'
import storage from '@/service/storage-service'
import jquery from 'jquery'
import md5 from '../service/md5-service'
import {
  Toast
} from 'vant'

axios.defaults.timeout = 15000
// axios.defaults.headers.post['dataType'] = 'json'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.common.AppId = 'jdf'
axios.defaults.AppId = 'jdf'

// axios.defaults.baseURL = 'http://192.168.0.147:8060/jdf'
// axios.defaults.baseURL = 'https://market.jiudaifu.com/jdf'
axios.defaults.baseURL = document.location.protocol + '//market.jiudaifu.com/jdf'
// axios.defaults.baseURL = 'http://120.79.28.173:8060/jdf'

axios.defaults.paramsSerializer = function (params) {
  if (typeof params == 'object') {
    var paramsCopy = JSON.parse(JSON.stringify(params))
    for (var k in paramsCopy) {
      if (typeof paramsCopy[k] == 'object') {
        paramsCopy[k] = JSON.stringify(paramsCopy[k])
      }
    }
  }
  return jquery.param(paramsCopy)
}
// 请求拦截器
axios.defaults.onReqSuccess = function (config) {
  let currentUser = storage.get('user')
  if (currentUser && currentUser.token) {
    config.headers.common.Authorization = currentUser.token
  }
  let sign = "";
  sign = create(config.params);
  let timestamp = new Date().getTime().toString()
  config.headers.common.Sign = sign
  config.headers.common.timestamp = timestamp
  return config
}
axios.defaults.onReqError = function (error) {
  return Promise.reject(error)
}
axios.defaults.onResSuccess = function (res) {
  if (res.data.errCode) {
    if (res.data.errCode == -3) {
      Toast.fail(res.data.errMsg)
      // message.warning('用户验证失败或登录超时')
      storage.clearSession()
      storage.clear()
      //router.push({name: 'login'})
    } else {
      Toast.fail(res.data.errMsg)
    }
  }
  return res.data
}

function getParamsStr(paramsStr) {
  var newUrl = paramsStr.split("&").sort().join("&");
  var url = newUrl + "&appSecret=uchar.cn";

  // console.log(url)
  return md5(url).toString();
}

function create(params) {
  var arr = [];
  for (var i in params) {
    if (params[i] instanceof Array) {
      continue
    } else {
      arr.push((i + "=" + params[i]));
    }

  }
  return getParamsStr(arr.join(("&")));
  // }
}
axios.defaults.onResError = function (error) {
  if (error.response && error.response.status == 401) {
    // message.warning('用户验证失败或登录超时')
    storage.clearSession()
    storage.clear()
    //router.push({name: 'login'})
  } else {
    Toast.fail(error.message)
  }
  return Promise.reject(error)
}

export default axios



// WEBPACK FOOTER //
// ./src/service/http-service.js